module.exports = __webpack_public_path__ + "img/Other2.1204831b.svg";